import React, { FC } from 'react';
import {
    Zone as ZoneFields,
    Matrix as MatrixFields,
} from '@/generated/graphql';
import NavItem from './NavItem';
import { useFoyerConfig } from '../FoyerProvider';
import { concatenateIdToPath } from '@/utils';
import classNames from 'classnames';

type NavAreaProps = {
    navAreaName: 'zone' | 'matrix';
    navArea: {
        parentId: number;
        parentPath: string;
        items: ZoneFields[] | MatrixFields[];
    };
};

const NavArea: FC<NavAreaProps> = ({ navAreaName, navArea }) => {
    const foyerConfig = useFoyerConfig();
    const isActive =
        foyerConfig.activeRealmItem?.id === navArea.parentId ||
        foyerConfig.activeZoneItem?.id === navArea.parentId;

    return (
        <section
            className={classNames('Nav_area', navAreaName, {
                isOpen: isActive,
            })}
        >
            {navArea.items.map((item) => (
                <NavItem
                    key={item.id}
                    navAreaName={navAreaName}
                    item={item}
                    path={`${navArea.parentPath}/${concatenateIdToPath({
                        id: item.id,
                        pathId: item.pathId,
                    })}`}
                    className={item.config}
                />
            ))}
        </section>
    );
};

export default NavArea;
